<template>
<div class="chapter">
<div class="inner_page">
<p class="chap-title1">Contents</p>
<p class="TOC"><a href="#/Foreword">Foreword, by Jim Allison</a></p>
<p class="TOC"><a href="#/Acknowledgements">Acknowledgements</a></p>
<p class="TOC"><a href="#/Introduction">Introduction</a></p>
<p class="TOC1"><a href="#/Chapter1">1. Amazon Rising</a></p>
<p class="TOC"><span href="#/Chapter2" title="Link target outside of Sample">2. Battle of the Sexes</span></p>
<p class="TOC"><span href="#/Chapter3" title="Link target outside of Sample">3. Guards of Honor</span></p>
<p class="TOC"><span href="#/Chapter4" title="Link target outside of Sample">4. Girl Guard Trivia</span></p>
<p class="TOC"><span href="#/Chapter5" title="Link target outside of Sample">5. Tactical Differences</span></p>
<p class="TOC"><span href="#/Chapter6" title="Link target outside of Sample">6. Uniforms</span></p>
<p class="TOC"><span href="#/Chapter7" title="Link target outside of Sample">7. Biographies</span></p>
<p class="TOC"><span href="#/Chapter8" title="Link target outside of Sample">8. Stitzer’s Other Guards</span></p>
<p class="TOC"><span href="#/Chapter9" title="Link target outside of Sample">9. Girl Cadets of Rawlins</span></p>
<p class="TOC"><span href="#/Chapter10" title="Link target outside of Sample">10. Girl Cadets of Laramie</span></p>
<p class="TOC1"><span href="#/Notes" title="Link target outside of Sample">Notes</span></p>
<p class="TOC"><span href="#/Bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="TOC"><span href="#/Author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?34950314